import React, { useState } from 'react'
import Gotop from "../components/gotop";
import AboutCorporatePage from './AboutCorporatePage';
import MobileHeader from "../components/header/MobileHeader";
import LoginHeader from "../components/header/LoginHeader";
import InstituteHeader from "../components/header/InstituteHeader";
import CRHeader from "../components/header/CRHeader";
import NonLoginHeader from "../components/header/NonLoginHeader";
import LoginMobileHeader from "../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../components/header/InstituteMobileHeader";
import CRMobileHeader from "../components/header/CRMobileHeader";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

function AboutCorporate() {

  const [isShowMobile, setShowMobile] = useState(false);

  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });


  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };



  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const module = localStorage.getItem('Module')


  return (

    <>
      <Helmet>
        <title>AboutCorporate | Jobkikhoj</title>
        <meta name="description" content=" " />
        <meta name="keywords" content=" " />
        <meta property="og:title" content="AboutCorporate | Jobkikhoj " />
        <meta property="og:description" content="" />
        <meta property="og:url" content="https://jobkikhoj.com" />
      </Helmet>


      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}

      {module === 'Candidate' ? <LoginHeader clname="managejobs" handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader clname="managejob" handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
              <NonLoginHeader clname="managejobs" handleMobile={handleMobile} />}

      <div className="pt-70">
        <AboutCorporatePage title="Corporate" />
        <Footer />
        <Gotop />
      </div>

    </>

  )
}

export default AboutCorporate